// extracted by mini-css-extract-plugin
export var originalPrice = "_w1-0";